import { graphql } from 'react-relay';

export default graphql`
  query ReferralCodeLookup_Query(
    $count: Int
    $sortBy: String
    $byReferralCode: String
  ) {
    viewer {
      id
      ...ReferralCodeLookup_viewer
        @arguments(
          count: $count
          byReferralCode: $byReferralCode
          sortBy: $sortBy
        )
    }
  }
`;
